import { useState } from "react";
import axios from "axios";
import { Loader2, MessageCircle } from "lucide-react";
import { useI18n } from "@/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const QuoteWhatsApp = ({ itemType, itemId, title, testIdPrefix = "quote" }) => {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  const [quantity, setQuantity] = useState("1");
  const [country, setCountry] = useState(localStorage.getItem("mb300_quote_country") || "");
  const [status, setStatus] = useState("idle");
  const copy = t.catalog.quote;

  const submit = async (event) => {
    event.preventDefault();
    setStatus("loading");
    const popup = window.open("", "_blank");
    try {
      const params = new URLSearchParams(window.location.search);
      const response = await axios.post(`${API}/catalog/quotes`, {
        item_type: itemType,
        item_id: itemId,
        quantity,
        country,
        lang,
        origin: window.location.pathname,
        campaign: params.get("utm_campaign") || params.get("utm_source") || "direct",
      });
      localStorage.setItem("mb300_quote_country", country);
      if (popup) popup.location.href = response.data.whatsapp_url;
      else window.location.assign(response.data.whatsapp_url);
      setStatus("success");
      setOpen(false);
    } catch {
      if (popup) popup.close();
      setStatus("error");
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" data-testid={`${testIdPrefix}-whatsapp-open`} className="inline-flex items-center justify-center gap-2 bg-[#25D366] px-5 py-3 text-sm font-bold text-[#07150C] transition-transform hover:-translate-y-0.5">
          <MessageCircle className="h-4 w-4" />{copy.button}
        </button>
      </DialogTrigger>
      <DialogContent data-testid={`${testIdPrefix}-whatsapp-dialog`} style={{ backgroundColor: "#0B1530" }} className="max-h-[90vh] w-[calc(100%-1.5rem)] overflow-y-auto border-white/15 text-white sm:max-w-md">
        <DialogHeader><DialogTitle className="font-display text-3xl uppercase">{copy.title}</DialogTitle></DialogHeader>
        <p className="text-sm text-[var(--steel)]" data-testid={`${testIdPrefix}-quote-item`}>{title}</p>
        <form onSubmit={submit} className="mt-4 grid gap-5">
          <label className="text-sm text-[var(--steel)]">{copy.quantity}
            <input type="number" min="1" max="9999" required value={quantity} onChange={(e) => setQuantity(e.target.value)} data-testid={`${testIdPrefix}-quantity`} className="mt-2 w-full border border-white/15 bg-[#070C1A] px-4 py-3 text-white outline-none focus:border-[var(--gold)]" />
          </label>
          <label className="text-sm text-[var(--steel)]">{copy.country}
            <input required minLength="2" maxLength="120" value={country} onChange={(e) => setCountry(e.target.value)} data-testid={`${testIdPrefix}-country`} className="mt-2 w-full border border-white/15 bg-[#070C1A] px-4 py-3 text-white outline-none focus:border-[var(--gold)]" />
          </label>
          {status === "error" && <p className="text-sm text-red-300" data-testid={`${testIdPrefix}-error`}>{copy.error}</p>}
          <button type="submit" disabled={status === "loading"} data-testid={`${testIdPrefix}-whatsapp-submit`} className="flex items-center justify-center gap-2 bg-[#25D366] px-5 py-3 font-bold text-[#07150C] disabled:opacity-60">
            {status === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : <MessageCircle className="h-4 w-4" />}{status === "loading" ? copy.loading : copy.submit}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};